import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import Utils from "../../../utils/Utils";
import store from '../../../store';


class GetBookmark extends AbstractRequestTask {

  constructor({group_id = '', version = 'v1', lastTouch}) {
    super();
    this._group_id = group_id;
    this.version = version;
    this.user = store.getState().user;
    this.lasttouch = lastTouch || (this.user && this.user.lasttouch ? this.user.lasttouch.seen : false);
  }

  getHeaders() {
    return {};
  }

    getUrl() {

      const protocol = 'https';
      const server = Launcher.get("akamai_mfwk");
      const endpoint = 'services/user';
      const version = this.version;
      const apiname = 'getbookmark';

      return `${protocol}://${server}/${endpoint}/${version}/${apiname}`;
    }

  getParams() {
    const params = super.getParams();
    const group_id = this._group_id;

    if (this.lasttouch) {
      params.lasttouch = this.lasttouch;
    }
    // Solo en esta api es filter_list y no  filterlist como en las demas
    //https://dlatvarg.atlassian.net/wiki/spaces/GCV/pages/267059977/user+getbookmark?focusedCommentId=621510829#comment-621510829
    const filter_list = Utils.getAPAFilterList();
    delete params.api_version;
    delete params.HKS;
    return Object.assign({}, params, { group_id, filter_list });
  }

  success(data, b) {
    this.resolve(data);
  }
}

export default GetBookmark;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/GetBookmarkTask.js